import { render, staticRenderFns } from "./InfoautoCustomerAddressPhonesModal.vue?vue&type=template&id=36081c56&scoped=true"
import script from "./InfoautoCustomerAddressPhonesModal.vue?vue&type=script&lang=js"
export * from "./InfoautoCustomerAddressPhonesModal.vue?vue&type=script&lang=js"
import style0 from "./InfoautoCustomerAddressPhonesModal.vue?vue&type=style&index=0&id=36081c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36081c56",
  null
  
)

export default component.exports